import { ChevronRight } from "lucide-react";

/** 56px row button per the Room Action Drawer spec. tone: secondary | primary | warning | error | success | info */
const TONES = {
  secondary: "bg-white border border-[#D5E6E8] hover:bg-[#F4FCFC] hover:border-[#37F4B5] text-[#1A2425]",
  primary: "bg-[#37F4B5] border border-transparent hover:bg-[#2CE3A6] text-[#014751]",
  warning: "bg-[#FEF3C7] border border-[#F59E0B] text-[#78530E] hover:brightness-[0.98]",
  error: "bg-[#FEE2E2] border border-[#DC2626] text-[#991B1B] hover:brightness-[0.98]",
  success: "bg-[#DBFCEF] border border-[#14C48E] text-[#014751] hover:brightness-[0.98]",
  info: "bg-[#E6FEFF] border border-[#37F4B5] text-[#014751] hover:brightness-[0.98]",
};

export function ActionButton({ icon: Icon, title, subtitle, tone = "secondary", onClick, disabled, testid, compact = false }) {
  const primary = tone === "primary";
  const iconColor = primary ? "#014751" : tone === "warning" ? "#78530E" : tone === "error" ? "#991B1B" : "#014751";
  return (
    <button type="button" onClick={onClick} disabled={disabled} data-testid={testid}
      className={`w-full rounded-lg px-4 flex items-center justify-between gap-3 text-left transition-[background-color,border-color] duration-150 disabled:opacity-50 disabled:cursor-not-allowed ${compact ? "h-11" : "h-14"} ${TONES[tone]}`}>
      <span className="flex items-center gap-3 min-w-0">
        {Icon && <Icon size={compact ? 18 : 22} strokeWidth={1.5} color={iconColor} className="shrink-0" />}
        <span className="min-w-0">
          <span className={`block font-bold leading-tight truncate ${compact ? "text-[13px]" : "text-[14px]"}`}>{title}</span>
          {subtitle && <span className={`block text-[12px] leading-tight truncate ${primary ? "text-[#01353D]" : tone === "secondary" ? "text-[#3F5257]" : "opacity-80"}`}>{subtitle}</span>}
        </span>
      </span>
      {!compact && <ChevronRight size={18} strokeWidth={1.5} color={primary ? "#014751" : "#97A6A9"} className="shrink-0" />}
    </button>
  );
}

export function SectionLabel({ children }) {
  return <div className="text-[11px] font-bold uppercase tracking-[0.12em] text-[#3F5257] mb-2" style={{ fontFamily: "var(--font-sans)" }}>{children}</div>;
}
